<template>
  <div class="table-row pinned-tab">
    <!-- <div class="report-side-panel bench-overview-side-panel q-box-shadow fromleft"> -->
    <div class="report-side-panel">
      <div class="sub-header">
        <!--- <report-header></report-header>-->
        <div class="date-range">
          <vue-monthly-picker :clearOption="false" v-model="dateIn" :monthLabels="monthLabels"></vue-monthly-picker>
          <div class="col position">
            <div class="select-wrapper" :class="employeeClassObject">
              <v-select
                :options="employeeData"
                label="EmployeeName"
                clear-button-icon="false"
                v-model="employee"
              ></v-select>
            </div>
          </div>
          <div class="download-button-wrapper">
            <a
              data-v-200367fa
              href
              class="cta-btn release-btn"
              @click.prevent="unReleaseEmpMonth()"
            >Unrelease</a>
          </div>
          <!-- <i class="csv-export button-export" @click.stop="exportExcel()"></i> -->
        </div>
      </div>
    </div>
      <transition name="modal" v-if="showAfterUnReleaseModal">
      <div class="modal-mask delete-modal-box">
        <div class="modal-wrapper">
          <div class="modal-container">
            <div>
              <div class="modal-header">
                <slot name="header">Successfully unreleased the selected month data</slot>
              </div>

              <div class="modal-body">
                <button class="modal-default-button cta-btn save-btn" @click="onClickClose">Close</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import VueMonthlyPicker from "vue-monthly-picker"; //https://www.npmjs.com/package/vue-monthly-picker
import _ from "lodash";
import moment from "moment";
export default {
  name: "QtimeActivityRelation",
  data: () => {
    return {
      error: false,
      masterTableWidth: 0,
      loadMore: true,
      timeout: 0,
      dateIn: moment(),
      monthLabels: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ],
      searchError: {
        sap_no: false,
        employment: false
      },
      projectModel: null
    };
  },
  components: {
    VueMonthlyPicker
  },
  computed: {
    podioUser: function() {
      return this.$store.state.auth.podio_user;
    },
    filter: function() {
      return this.$store.state.qtimeReports.unreleasefilter;
    },
    employeeData: function() {
      let employeeData = _.cloneDeep(this.$store.state.qtimeReports.releasedemployeesData);
      if (employeeData != null) {
        employeeData.push({ EmployeeId: 0, EmployeeName: "Choose Employee" });
      }
      
      return employeeData;
    },
    employee: {
      get: function() {
          let employee = this.employeeData.find(
          x => x.EmployeeId === this.$store.state.qtimeReports.unreleasefilter.EmployeeId
        );
        if(employee==undefined)
        {
            return employee = this.employeeData.find(
            x => x.EmployeeId === 0
          );
        }
        return employee;

      },
      set: function(value) {
        this.$store.commit("setFilterReleaseEmployeeId", value);
      }
    },
    employeeClassObject: function() {
      return { "error-border": this.error };
    },
    showAfterUnReleaseModal:function(){
        return this.$store.state.forecast.globalSuccessUnRelease;
    },
  },
  beforeMount() {
    // let filter = _.cloneDeep(this.filter);
    // filter.ProjectId =0;
    // filter.EmployeeId =0;
    // filter.date = this.dateIn.format("MM-YYYY");
    // this.$store.dispatch("fetchQTimeActivity", filter);
     this.$store.commit("setUnReleasedDateIn", this.dateIn.format("MM-YYYY"));
      let filter = _.cloneDeep(this.filter);
      filter.EmployeeId =0;
      filter.date = this.dateIn.format("MM-YYYY");
      this.$store.dispatch("fetchReleaseEmpMonthData", filter);
  },
  methods: {
    fetchUpdatedReport: function() {
      // clone the current filter
      let filter = _.cloneDeep(this.filter);
      this.$store.dispatch("fetchReleaseEmpMonthData", filter);
    },
    unReleaseEmpMonth: function() {
      if (
        this.employee !== undefined &&
        this.employee.EmployeeId > 0
      ) {
        this.error = false;
        let filter = _.cloneDeep(this.filter);
        // send request
        this.$store.dispatch("UnReleaseEmpMonth", filter);
      } else {
        this.error = true;
      }
    },
    onClickClose: function () {
      this.$store.state.forecast.globalSuccessUnRelease = false;
       let filter = _.cloneDeep(this.filter);
       filter.EmployeeId =0;
      filter.date = this.dateIn.format("MM-YYYY");
      this.$store.dispatch("fetchReleaseEmpMonthData", filter);
    },
  },
  updated() {},
  mounted() {},

  destroyed() {},
  watch: {
    dateIn: function() {
      this.$store.commit("setUnReleasedDateIn", this.dateIn.format("MM-YYYY"));
      let filter = _.cloneDeep(this.filter);
      filter.EmployeeId =0;
      filter.date = this.dateIn.format("MM-YYYY");
      this.$store.dispatch("fetchReleaseEmpMonthData", filter);
      //this.fetchUpdatedReport();
    },
    employeeData: {
      handler: function(val) {
        if(val.find(x => x.ItemId === this.podioUser.itemId)!=null && this.employee.EmployeeId == 0)
        {
            let employee = val.find(x => x.EmployeeId === this.podioUser.itemId);
            this.employee= employee;
        }
      },
      deep: true,
      immediate: true
    } 
  }
};
</script>
<style scoped>
.error-border {
  border: 1px solid red;
}

.table-row {
  padding: 20px 20px 10px 20px;
  background: none;
  border: 1px solid rgba(192, 192, 192, 0.3411764705882353);
  border-radius: 11px;
}

.qtime-activity-view {
  width: 100%;
}

.table-row .position {
  width: 100%;
  max-width: 100%;
  padding: 0;
  margin-bottom: 10px;
}

.month-year-label {
  margin-bottom: 10px;
}

.download-button-wrapper {
  width: 100%;
  text-align: center;
}

.cta-btn {
  padding: 7px 19px;
  margin: 0 auto;
}


.sub-header .date-range,
.sub-header{
  border-top: none !important;
  border-bottom: none !important;
}

.table-row{
  height: 206px;
}



@media screen and (max-width: 1573px){
  .sub-header .date-range{
      padding-left: 0;
      }
}

.modal-mask {
		position: fixed;
		z-index: 9998;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.5);
		display: table;
		transition: opacity 0.3s ease;
	}

	.modal-wrapper {
		display: table-cell;
		vertical-align: middle;
	}

	.modal-container {
		width: 300px;
		margin: 0px auto;
		padding: 20px 30px;
		background-color: #fff;
		border-radius: 2px;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
		transition: all 0.3s ease;
		font-family: Helvetica, Arial, sans-serif;
	}

	.modal-container .cta-btn {
		padding: 5px 14px;
		background: #ffffff;
		font-size: 11px;
		/*margin-right: 5px;*/
	}

	.modal-container .cta-btn:hover,
	.modal-container .cta-btn.active {
		background-color: #003656;
		color: #fff;
	}

	.delete-modal-box .modal-container {
		width: 450px;
		min-height: 170px;
		display: flex;
		display: -webkit-flex;
		display: -moz-flex;
		justify-content: center;
		-webkit-justify-content: center;
		-moz-justify-content: center;
		flex-wrap: wrap;
		-webkit-flex-wrap: wrap;
		align-items: center;
		-moz-align-items: center;
		-webkit-align-items: center;
	}

	.delete-modal-box .modal-container .modal-default-button {
		float: center;
	}

	.delete-modal-box .modal-container .modal-body:after {
		content: "";
		display: table;
		clear: both;
	}

	.modal-header h3 {
		margin-top: 0;
		color: #42b983;
		text-align: center;
	}

	.delete-modal-box .modal-header {
		width: 100%;
		margin-bottom: 20px;
	}

	.delete-modal-box .modal-header h3 {
		color: #8f8f8f;
	}
	.delete-modal-box .modal-body {
		margin: 10px 0;
		display: flex;
		display: -webkit-flex;
		display: -moz-flex;
		justify-content: center;
		-webkit-justify-content: center;
		-moz-justify-content: center;
		align-items: center;
		-moz-align-items: center;
		-webkit-align-items: center;
	}

	.modal-default-button {
		float: right;
	}

	.modal-enter {
		opacity: 0;
	}

	.modal-leave-active {
		opacity: 0;
	}

	.modal-enter .modal-container,
	.modal-leave-active .modal-container {
		-webkit-transform: scale(1.1);
		transform: scale(1.1);
	}
</style>